import { MarqueeRow } from "../shared";
import {
  BenzingaLogo,
  BinanceLogo,
  ManilaTimesLogo,
  BusinessInsidersLogo,
  CoinMarketCapLogo,
  StreetInsiderLogo,
  BTCLogo,
  APNewsLogo,
  CryptoBriefingLogo,
  AnalyticsInsightLogo,
  MPostLogo,
  InvestingComLogo,
  CoinEditionLogo,
  TheNewsCryptoLogo,
  TechBullionLogo,
} from "./MarqueeLogos";

export default function PressMarquee() {
  return (
    <section className="py-10 px-6 overflow-hidden relative bg-[#0a0a0a]">
      <div className="w-full mx-auto">
        <MarqueeRow speed={45}>
          <div className="flex gap-14 md:gap-20 px-8 items-center text-white/[0.2] hover:[&>a]:text-white/40 [&>a]:transition-colors [&>a]:duration-700 [&>a]:cursor-pointer">
            <a
              href="https://www.benzinga.com/pressreleases/25/10/g47970991/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BenzingaLogo />
            </a>
            <a
              href="https://www.binance.com/en/square/post/30431552052393"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BinanceLogo />
            </a>
            <a
              href="https://www.manilatimes.net/2025/10/01/tmt-newswire/globenewswire/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x/2193347"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ManilaTimesLogo />
            </a>
            <a
              href="https://markets.businessinsider.com/news/stocks/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x-1035244664"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BusinessInsidersLogo />
            </a>
            <a
              href="https://coinmarketcap.com/community/articles/68dd1dda6217ba7fe64b9779"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CoinMarketCapLogo />
            </a>
            <a
              href="https://www.streetinsider.com/Globe+Newswire/AGNT+Hub+Launches+X+Mini+Apps+and+Opens+the+Next+Chapter+for+Native+Web3+on+X/25404728.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <StreetInsiderLogo />
            </a>
            <a
              href="https://news.bitcoin.com/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BTCLogo />
            </a>
            <a
              href="https://apnews.com/press-release/globenewswire-mobile/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x-2d72090425a8d74173a19b74404d7cd0"
              target="_blank"
              rel="noopener noreferrer"
            >
              <APNewsLogo />
            </a>
            <a
              href="https://cryptobriefing.com/web3-mini-apps-x-launch/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CryptoBriefingLogo />
            </a>
            <a
              href="https://www.analyticsinsight.net/cryptocurrency-analytics-insight/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AnalyticsInsightLogo />
            </a>
            <a
              href="https://mpost.io/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <MPostLogo />
            </a>
            <a
              href="https://www.investing.com/news/press-releases/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x-4266738"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InvestingComLogo />
            </a>
            <a
              href="https://coinedition.com/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CoinEditionLogo />
            </a>
            <a
              href="https://thenewscrypto.com/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <TheNewsCryptoLogo />
            </a>
            <a
              href="https://techbullion.com/agnt-hub-launches-x-mini-apps-and-opens-the-next-chapter-for-native-web3-on-x/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <TechBullionLogo />
            </a>
          </div>
        </MarqueeRow>
      </div>
    </section>
  );
}
